import { useLayoutEffect, useState } from 'react';
import { Router } from 'react-router-dom';
import history from '@history';
import { PENDING_PARAMS_KEY, PENDING_URL_KEY } from 'src/app/configs/settingsConfig';

// -------- Captura de url inicial
const initialUrl = window.location.pathname;
const initialParams = window.location.search;

// -------- Guardado de url en sesion storage
if (!sessionStorage.getItem(PENDING_URL_KEY)) {
  sessionStorage.setItem(PENDING_URL_KEY, initialUrl);
}

if (!sessionStorage.getItem(PENDING_PARAMS_KEY)) {
  sessionStorage.setItem(PENDING_PARAMS_KEY, initialParams);
}

function BrowserRouter({ basename, children }) {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(
    () => history.listen(({ location, action }) => setState({ location, action })),
    [history]
  );

  return (
    <Router
      basename={basename}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    >
      {children}
    </Router>
  );
}

export default BrowserRouter;
